import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { UpdateUserGroupView } from './create/updateUserGroup.view';
import { CreateUserGroupView } from './create/createUserGroup.view';
import { UserGroupsView } from './userGroups.view';

/**
 * Routeur pour la gestion des groupes d'utilisateurs
 *
 * Ce routeur gère la navigation entre :
 * - Liste des groupes (/user-groups)
 * - Création de groupe (/user-groups/create)
 * - Modification de groupe (/user-groups/:id)
 *
 * Logique métier :
 * - Route par défaut vers la liste des groupes
 * - Route de création avec formulaire vide
 * - Route de modification avec chargement du groupe existant
 *
 * @returns Composant React du routeur des groupes d'utilisateurs
 */
export const UserGroupRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <UserGroupsView />
        </Route>
        <Route path={`${path}/create`}>
          <CreateUserGroupView />
        </Route>
        <Route path={`${path}/:id`}>
          <UpdateUserGroupView />
        </Route>
      </Switch>
    </div>
  );
};
